import { normalizePopupLayout } from "./popupLayout";

/**
 * When the merchant picks Template 3 (dark panel), apply readable button + border defaults.
 * Title/description colors stay as stored so switching to templates 1–4 does not inherit light-on-dark copy.
 */
export function mergeLayoutThemedPopup(prevPopup, rawLayout) {
  const next = normalizePopupLayout(rawLayout);
  const base = { ...prevPopup, layout: next };
  if (next !== "3") return base;
  return {
    ...base,
    buttons: {
      ...base.buttons,
      accept: {
        ...base.buttons?.accept,
        background: "#fafafa",
        color: "#1c1917",
        borderColor: "#e7e5e4",
      },
      reject: {
        ...base.buttons?.reject,
        background: "#44403c",
        color: "#fafafa",
        borderColor: "#57534e",
      },
    },
    popupStyle: {
      ...base.popupStyle,
      borderColor: "rgba(255,255,255,0.14)",
    },
  };
}
